import { define } from 'wicked-elements'
import { Fancybox } from '@fancyapps/ui'

define('a[href$="?s="]', {
  init() {
    this.modalTemplate = document.querySelector('#search-modal-template') 
    this.$modalNode = this.modalTemplate?.content?.children?.[0]
  },
  onClick(e) {
    if (!this.$modalNode) return;

    e.preventDefault()
    new Fancybox([
        {
          src: this.$modalNode.outerHTML,
          type: "html",
        },
      ], {
      defaultType: 'html',
      contentClick: false, // clicking on an image goes to next slide
      commonCaption: true, // turn on single element caption
      wheel: false, // de-activate any functionality on mousewheel
      idle: false, // de-activate icons disappearing when idle
      mainClass: 'search-modal',
      animated: false,
      showClass: false,
      hideClass: false,
      compact: false,
      dragToClose: false,
      autoFocus: false,
      keyboard: {
        Backspace: false,
        Delete: false
      },
      Carousel: {
        transition: false,
      },
      Toolbar: {
        enabled: true,
        items: {
          // create a custom buttons so we can use the font glyphs
          close: {
            tpl: `<button class="f-button" data-fancybox-close>&#10005;</button>`,
          },
        },
        display: {
          left: [],
          middle: [],
          right: ['close'],
        },
      },
      Slideshow: false, // disable autoplay slideshow functionality
      Thumbs: false, // disable thumbnail navigation
      on: {
        ready: () => {
          window.dispatchEvent(new CustomEvent('cmoa:search-modal', { detail: { open: true } }))
        },
        destroy: () => {
          window.dispatchEvent(new CustomEvent('cmoa:search-modal', { detail: { open: false } }))
        }
      }
    });
  },
})